import { RoleHost } from '../RoleHost';

export function OLWrapper() {
  return <RoleHost role="ol" />;
}
